<script setup lang="ts">
import { Form, Head } from '@inertiajs/vue3'

import AuthLayout from '@/layouts/AuthLayout.vue'
import { firstFormError } from '@/lib/forms'
import { identityPasswordResetPath, signInPath } from '@/routes'
</script>

<template>
  <AuthLayout
    title="Forgot password"
    description="Enter your email to receive a password reset link"
  >
    <Head title="Forgot password" />

    <div class="space-y-6">
      <Form
        v-slot="{ errors, processing }"
        method="post"
        :action="identityPasswordResetPath()"
      >
        <UFormField
          label="Email address"
          name="email"
          :error="firstFormError(errors.email)"
        >
          <UInput
            id="email"
            name="email"
            type="email"
            autocomplete="off"
            autofocus
            placeholder="email@example.com"
            icon="i-lucide-mail"
            class="w-full"
          />
        </UFormField>

        <div class="my-6 flex items-center justify-start">
          <UButton
            type="submit"
            class="w-full"
            :loading="processing"
            label="Email password reset link"
            icon="i-lucide-send"
          />
        </div>
      </Form>

      <div class="text-muted space-x-1 text-center text-sm">
        <span>Or, return to</span>
        <ULink :to="signInPath()" class="text-primary font-medium">
          log in
        </ULink>
      </div>
    </div>
  </AuthLayout>
</template>
